import styled from 'styled-components'
import { mobileS, mobileM, mobileL } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const TinderBtnsWrapper = styled.div`
  .btn-container {
    display: flex;
    gap: 10px;
    position: absolute;
    bottom: 1.5rem;
    left: 3rem;
    right: 3rem;
    padding: 0rem;

    @media only screen and (max-height: 900px) and (max-width: 600px) {
      padding-bottom: 5vh;
    }

    ${mobileL({
      display: 'flex',
      flexDirection: 'column',
      bottom: '3.5rem',
    })};

    ${mobileM({
      left: '2rem',
      right: '2rem',
    })};

    ${mobileS({
      left: '1rem',
      right: '1rem',
    })};

    button {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
  }
`
